var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status.length)?_c('div',{staticClass:"ecm-status"},[_c('ul',{staticClass:"ecm-status-list"},_vm._l((_vm.status),function(statusText){return _c('li',{key:statusText},[_vm._v(" "+_vm._s(statusText)+" ")])}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }